import React, { useRef, useEffect, useState } from "react";
import axiosInstance from "../../utils/axios";

const VideoContainer = () => {
  const videoRefs = useRef([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Function to pause other videos
  const handlePlay = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (i !== index && video) {
        video.pause();
      }
    });
  };

  // Fetch testimonials from API
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        setLoading(true);
        setError("");
        const resp = await axiosInstance.get("/testimonials");
        console.log("Fetched testimonials:", resp.data);
        setVideos(resp?.data || []);
      } catch (err) {
        console.error("Error fetching testimonials:", err);
        setError("Failed to load testimonials");
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  if (loading) {
    return (
      <div className="w-full flex justify-center items-center py-20">
        <p className="text-lg font-semibold text-gray-600">
          Loading testimonials...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full flex justify-center items-center py-20">
        <p className="text-lg font-semibold text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="w-full bg-gradient-to-br from-gray-50 to-gray-100 py-10 md:px-10 px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {videos.map((video, index) => (
          <div
            key={video._id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300"
          >
            <video
              ref={(el) => (videoRefs.current[index] = el)}
              src={video.videoUrl}
              controls
              className="w-full h-72 object-cover"
              onPlay={() => handlePlay(index)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoContainer;
